module.exports = __webpack_public_path__ + "static/media/esnet-logo.9cd4f5f3.png";